(function () {
  'use strict';

  angular
    .module('factories.storage', ['factories.mobileHelper'])
    .factory('Storage', Storage);

  Storage.$inject = ['NativeBridge', '$window', 'MobileHelper'];

  function Storage(NativeBridge, $window, MobileHelper) {
    var exports = {};

    if (MobileHelper.isNativeIpadApp) {
      useNativeStorage();
    } else {
      // safari in private browser will throw
      // QuotaExceededError: DOM Exception 22
      // if you try and write to localstorage
      try {
        $window.localStorage.setItem("storage", "");
        $window.localStorage.removeItem("storage");
        useLocalStorage();
      } catch (err) {
        useDummyStorage();
      }
    }

    function useDummyStorage() {
      var structureLocalStorage = {};
      exports.setValue = function (key, value) {
        structureLocalStorage[key] = value;
      };

      exports.getValue = function (key) {
        if (typeof structureLocalStorage[key] != 'undefined') {
          return structureLocalStorage[key];
        } else {
          return null;
        }
      };

      exports.clearValue = function (key) {
        structureLocalStorage[key] = undefined;
      };
    }

    function useNativeStorage() {
      exports.setValue = nativeSetValue;
      exports.getValue = nativeGetValue;
      exports.clearValue = nativeClearValue;
    }

    function useLocalStorage() {
      exports.setValue = localSetValue;
      exports.getValue = localGetValue;
      exports.clearValue = localClearValue;
    }


    function nativeSetValue(key, value) {
      value = angular.toJson(value);
      $window.storage[key] = value;
      NativeBridge.send({'command': 'setValue', 'key': key, 'value': value});
    }

    function nativeGetValue(key) {
      var value = $window.storage[key];
      if (value) {
        return JSON.parse($window.storage[key]);
      } else {
        return null;
      }
    }

    function nativeClearValue(key) {
      delete $window.storage[key];
      NativeBridge.send({'command': 'clearValue', 'key': key});
    }

    function localSetValue(key, value) {
      value = angular.toJson(value);
      $window.localStorage[key] = value;
    }

    function localGetValue(key) {
      var value = null;
      if ($window.localStorage && $window.localStorage[key])
        value = $window.localStorage[key];
      if (value === undefined)
        return undefined;
      return JSON.parse(value);
    }

    function localClearValue(key) {
      delete $window.localStorage[key];
    }

    return exports;
  }

})();
